import { css } from "lit";

export const styles = css`
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: var(--sds-color-background-default-default);
    --wow-input-padding: 10px 12px;
    --wow-input-padding-inline: 12px;
  }

  .page-container {
    flex: 1;
    overflow-y: auto;
    padding: 24px;
    width: 100%;
    box-sizing: border-box;
  }

  .page-layout {
    display: grid;
    grid-template-columns: 1fr 2fr;
    flex: 1;
    overflow: hidden;
  }

  .page-left-column {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
    padding: 24px 24px 0;
    border-right: 1px solid var(--sds-color-border-default-default);
    box-sizing: border-box;
  }

  .page-left-scroll {
    flex: 1;
    overflow: hidden auto;
    min-height: 0;
    padding-bottom: 24px;
  }

  .page-right-column {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    min-height: 0;
  }

  .page-header {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    padding: 24px 24px var(--sds-size-space-1200);
    border-bottom: 1px solid var(--sds-color-border-default-default);
  }

  .page-title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-06) var(--sds-typography-family-title);
    color: var(--sds-color-text-default-default);
    margin: 0;
    line-height: 20px;
  }

  .page-subtitle {
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-medium) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
    margin: 0;
  }

  .form-panel {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
    padding-top: var(--sds-size-space-600);
  }

  .form-panel-label {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    color: var(--sds-color-text-default-default);
    margin: 0;
  }

  .form-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .form-section-label {
    font: var(--sds-typography-weight-medium) var(--sds-typography-body-size-large) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .toggle-field {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .toggle-sub-fields {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
    padding-top: var(--sds-size-space-400);
  }

  .schedule-row {
    display: flex;
    gap: var(--sds-size-space-800);
  }

  .schedule-row wow-input[type="date"],
  .schedule-row wow-input[type="time"] {
    --wow-input-padding: 10px 6px;
    --wow-input-padding-inline: 6px;
  }

  .input-icon-wrapper {
    position: relative;
    flex: 1 1 140px;
  }

  .input-icon {
    position: absolute;
    right: 10px;
    top: 30px;
    height: var(--wow-input-height, 56px);
    display: flex;
    align-items: center;
    pointer-events: none;
    color: var(--sds-color-text-default-secondary);
    line-height: 0;
  }

  .content-panel {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-1600);
    padding: var(--sds-size-space-1200);
  }

  .content-panel-label {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    color: var(--sds-color-text-default-default);
    margin: 0;
    padding: 32px 32px;
    border-bottom: 1px solid var(--sds-color-border-default-default);
  }

  .char-count {
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-small) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
    text-align: left;
    margin-top: var(--sds-size-space-300);
  }

  /* Footer */
  .page-footer {
    flex-shrink: 0;
    padding: 16px 24px;
    background: var(--sds-color-background-default-default);
    border-top: 1px solid var(--sds-color-border-default-default);
  }

  .footer-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  .footer-left {
    display: flex;
    align-items: center;
  }

  .footer-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  /* Mobile tab content */
  .mobile-content-tab,
  .mobile-settings-tab {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
    padding-top: 24px;
  }

  @media (max-width: 1100px) {
    .page-layout {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 768px) {
    :host {
      overflow-y: auto;
    }

    .page-container {
      padding: var(--sds-size-space-800);
    }

    .mobile-textarea-wrapper .message-textarea::part(textarea) {
      min-height: 40vh;
    }

    .mobile-settings-tab > .toggle-field:first-child wow-switch {
      --wow-switch-border-top: none;
    }

    .page-header {
      padding-bottom: 0;
      border-bottom: none;
    }

    .mobile-title {
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      padding-bottom: var(--sds-size-space-800);
      margin-left: calc(-1 * var(--sds-size-space-800));
      margin-right: calc(-1 * var(--sds-size-space-800));
      color: var(--sds-color-text-brand-default);
    }

    .page-footer {
      padding: 12px 16px;
    }

    .footer-actions {
      width: 100%;
      justify-content: space-between;
    }

    .schedule-row {
      flex-direction: row;
    }
  }

  /* Segment Picker */
  .segment-picker {
    border: 1px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    overflow: hidden;
  }

  .segment-picker-header {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;
    gap: 8px;
  }

  .segment-search-wrapper {
    flex: 1;
    min-width: 0;
  }

  .segment-search {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-medium) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .segment-search::placeholder {
    color: var(--sds-color-text-default-tertiary);
  }

  .segment-chevron {
    font-size: 10px;
    color: var(--sds-color-text-default-secondary);
    transition: transform 0.2s ease;
  }

  .segment-chevron.expanded {
    transform: rotate(180deg);
  }

  .segment-picker-list {
    border-top: 1px solid var(--sds-color-border-default-default);
    max-height: 200px;
    overflow-y: auto;
  }

  .segment-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    cursor: pointer;
  }

  .segment-item:hover {
    background: var(--sds-color-background-default-secondary);
  }

  .segment-item input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: var(--sds-color-background-brand-default);
    cursor: pointer;
    flex-shrink: 0;
  }

  .segment-label {
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-medium) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .segment-loading,
  .segment-empty {
    padding: 12px;
    text-align: center;
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-small) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
  }

  .segment-error {
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-small) var(--sds-typography-family-body);
    color: var(--sds-color-text-danger-secondary);
  }

  /* Custom input overrides */
  wow-input {
    --wow-input-label-color: var(--sds-color-text-default-tertiary);
    --wow-input-placeholder-padding-top: 18px;
    --wow-input-label-white-space: normal;
  }

  wow-textarea {
    --wow-input-label-color: var(--sds-color-text-default-tertiary);
    --wow-input-label-white-space: normal;
  }

  .message-textarea::part(textarea) {
    min-height: 200px;
  }

  .image-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .image-section .form-section-label {
    font:
      var(--sds-typography-weight-medium) var(--sds-typography-body-size-large) / 100%
        var(--sds-typography-family-title),
      sans-serif;
    color: var(--sds-color-text-default-tertiary);
  }

  .image-uploader-container {
    display: flex;
    aspect-ratio: 16 / 9;
    border-radius: var(--sds-size-radius-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    overflow: hidden;
    margin-top: var(--sds-size-space-400);
  }

  .image-uploader-container media-uploader {
    width: 100%;
    height: 100%;
    --media-uploader-placeholder-background: transparent;
  }

  .image-readonly-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .image-helper-text {
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-small) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
  }

  .image-remove-row {
    display: flex;
    margin-top: var(--sds-size-space-300);
  }

  .test-send-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .test-send-controls {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .test-send-helper {
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-small) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
    margin-top: var(--sds-size-space-300);
  }

  .test-send-button-row {
    display: flex;
    margin-top: var(--sds-size-space-400);
  }
`;
